module.exports = __webpack_public_path__ + "images/14b068bb25224d4f5d5e60eac683bf42dea7bdda184508875616f645f58a6c58.svg";